var exports = {
  "ci": "TextareaInput.module__textareaContainer___Vy11Rn",
  "yF": "TextareaInput.module__divider___Vy11Rn",
  "Ot": "TextareaInput.module__textareaOuter___Vy11Rn",
  "WJ": "TextareaInput.module__collapsibleSection___Vy11Rn",
  "qp": "TextareaInput.module__inputSection___Vy11Rn",
  "aq": "TextareaInput.module__textareaOuterMobile___Vy11Rn",
  "AE": "TextareaInput.module__mainWrapperDense___Vy11Rn",
  "bx": "TextareaInput.module__mainWrapperEditing___Vy11Rn",
  "m$": "TextareaInput.module__uploadButtonColumn___Vy11Rn",
  "D4": "TextareaInput.module__sideButtonPadding___Vy11Rn",
  "Qh": "TextareaInput.module__plusButtonAboveBackdrop___Vy11Rn",
  "Sr": "TextareaInput.module__contentAreaDense___Vy11Rn",
  "h": "TextareaInput.module__contentAreaEditing___Vy11Rn",
  "l7": "TextareaInput.module__buttonContainerDense___Vy11Rn",
  "ae": "TextareaInput.module__buttonContainerEditing___Vy11Rn",
  "ou": "TextareaInput.module__textareaOuterRow___Vy11Rn",
  "o_": "TextareaInput.module__textareaOuterBare___Vy11Rn",
  "nw": "TextareaInput.module__mainWrapperBare___Vy11Rn",
};

module.exports = exports;
